import TableRow from '@mui/material/TableRow';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';

type Props = {
  row: any;
};

export default function InstallReferrerTableRow({ row }: Props) {
  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.id} />
        <AppTableCell value={row?.utm_source} />
        <AppTableCell value={row?.utm_medium} />
        <AppTableCell value={row?.utm_campaign} />
        <AppTableCell value={row?.install_referrer} />
        <AppTableCell value={new Date(row?.install_begin_timestamp)?.toLocaleDateString()} />
        <AppTableCell value={new Date(row?.click_timestamp)?.toLocaleDateString()} />
      </TableRow>
    </>
  );
}
